import angular from 'angular';
import verifyAccountConfig from './verify-account.config';

import verifyAccount from '../../containers/verify-account';

const verifyAccountModule = angular.module('meredicte.verifyAccount', [])
  .component('verifyAccount', verifyAccount)
  .config(verifyAccountConfig);

export default verifyAccountModule;



// WEBPACK FOOTER //
// ./src/modules/verify-account/verify-account.module.js